import { NgModule } from "@angular/core";
import { NavComponent } from "./nav/nav";
import { BrowserModule } from "@angular/platform-browser";
import { IonicModule } from "ionic-angular";
import { FlashCardContainerComponent } from "./flash-card-container/flash-card-container";
import { FooterComponent } from "./footer/footer";
import { SorobanMathContainerComponent } from "./soroban-math-container/soroban-math-container";
import { SidebarComponent } from "./sidebar/sidebar";
import { SummaryComponent } from "./summary/summary";
import { TranslateModule } from "@ngx-translate/core";
import { GameRoomComponent } from "./game-room/game-room";
import { ParentComponent } from "./parent/parent";
import { ProgressBarModule } from "angular-progress-bar";
import { ParentalGateComponent } from "./parental-gate/parental-gate";
import { LearnEnglishComponent } from "./learn-english/learn-english";

@NgModule({
  declarations: [
    NavComponent,
    FlashCardContainerComponent,
    FooterComponent,
    SorobanMathContainerComponent,
    SidebarComponent,
    SummaryComponent,
    GameRoomComponent,
    ParentComponent,
    ParentalGateComponent,
    LearnEnglishComponent,
  ],
  imports: [BrowserModule, IonicModule, TranslateModule, ProgressBarModule],
  exports: [
    ProgressBarModule,
    NavComponent,
    FlashCardContainerComponent,
    FooterComponent,
    SorobanMathContainerComponent,
    SidebarComponent,
    SummaryComponent,
    GameRoomComponent,
    ParentComponent,
    ParentalGateComponent,
    LearnEnglishComponent,
  ],
  entryComponents: [LearnEnglishComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts